import { Center } from '@chakra-ui/react'
import React, { useContext, useEffect } from 'react'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import { usePdfView } from './context'
import './styles.css'

import { ScreenContext } from '@hb/react'

export const PageNumberIndicator = ({
  containerRef,
  scrollRef,
}: {
  containerRef: React.RefObject<HTMLDivElement | null>
  scrollRef: React.RefObject<HTMLDivElement | null>
}) => {
  const {
    onScrollPage: setPage,
    scrollPageIndex: pageIndex,
    numPages,
    pageSizes,
    viewWidth,
  } = usePdfView()
  const screen = useContext(ScreenContext)
  useEffect(() => {
    const container = containerRef.current
    const scroll = scrollRef.current
    if (numPages === null || !container || !scroll) return () => {}
    const pages = container.querySelectorAll('.pdf-view-page-container')
    const pageHeights = Array.from(pages).map((_, i) => {
      const pageScale = viewWidth / pageSizes[i + 1][0]
      return pageSizes[i + 1][1] * pageScale
    })

    const onScroll = () => {
      const { scrollTop } = scroll ?? {}
      if (scrollTop === undefined) return
      let sum = 0
      let scrollPage = 0
      for (let i = 0; i < pageHeights.length; i += 1) {
        sum += pageHeights[i]
        if (sum > scrollTop + pageHeights[i] / 3) {
          scrollPage = i
          break
        }
      }
      setPage(scrollPage)
    }
    scroll.addEventListener('scroll', onScroll, { passive: true })
    scroll.addEventListener('wheel', onScroll, { passive: true })
    return () => {
      scroll.removeEventListener('scroll', onScroll)
      scroll.removeEventListener('wheel', onScroll)
    }
  }, [containerRef, numPages, screen, scrollRef, setPage, pageSizes, viewWidth])
  return (
    <Center w="100%" position="absolute" bottom="10px">
      <Center
        bg="rgba(0,0,0,0.3)"
        color="white"
        fontSize="sm"
        fontWeight={600}
        zIndex={3}
        height="30px"
        p={1}
        px={4}
        borderRadius={4}
        boxShadow="inset 0 0 6px rgba(0,0,0,0.4)"
        textShadow="0 0 3px black">
        {numPages !== null ? `Page ${pageIndex + 1} / ${numPages}` : 'Loading...'}
      </Center>
    </Center>
  )
}
